import { html, LitElement } from 'lit';
import { DebugService } from '../../shared/services/debug.service.js';
import { VehicleAndLoanService } from '../../services/vehicle-and-loan.service.js';
import './iconic-choose-vehicle-loan/iconic-choose-vehicle-loan.component.js';

class RefiIconicVehicleLoan extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicVehicleLoan');
    this.vehicleAndLoanList = VehicleAndLoanService.vehicleAndLoanMatchList;
  }

  static properties = {
    vehicleList: { type: Array },
    loanList: { type: Array },
    loading: { type: Boolean },
  };

  connectedCallback() {
    super.connectedCallback();
    this.vehicleAndLoanList = VehicleAndLoanService.vehicleAndLoanMatchList;
  }

  goToVehicle() {
    this.dispatchEvent(new CustomEvent('next-step'));
  }

  render() {
    this.debug.log('rendering');
    return html`<refi-track-pageview
        pagename="find your car"
      ></refi-track-pageview>
      <refi-iconic-choose-vehicle-loan
        .vehicleAndLoanMatchList="${this.vehicleAndLoanList}"
      ></refi-iconic-choose-vehicle-loan>`;
  }
}
customElements.define('refi-iconic-vehicle-loan', RefiIconicVehicleLoan);
